import type { SVGProps } from 'react';

export const DoubleArrowLeftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M18.7071 6.29285C18.3165 5.90254 17.6842 5.90237 17.2937 6.29285L12.2942 11.2934C11.9036 11.6839 11.9036 12.3161 12.2942 12.7067L17.2937 17.7072C17.6842 18.0976 18.3165 18.0974 18.7071 17.7072C19.0976 17.3166 19.0976 16.6845 18.7071 16.2939L14.413 12L18.7071 7.70614C19.0976 7.31558 19.0976 6.68342 18.7071 6.29285Z" />
    <path d="M11.707 6.29285C11.3165 5.90234 10.6842 5.90243 10.2936 6.29285L5.29293 11.2934C4.90236 11.6839 4.90236 12.3161 5.29293 12.7067L10.2936 17.7072C10.6842 18.0975 11.3165 18.0977 11.707 17.7072C12.0974 17.3167 12.0973 16.6844 11.707 16.2939L7.41295 12L11.707 7.70614C12.0974 7.31564 12.0973 6.68339 11.707 6.29285Z" />
  </svg>
);
